import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CanDeleteBoardOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanDeleteBoardOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"admins"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boardDeleteRestrict"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"private"}},{"kind":"Field","name":{"kind":"Name","value":"org"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CanDeleteBoardOrganization","document":CanDeleteBoardOrganizationDocument}} as const;
export type CanDeleteBoardOrganizationQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
}>;


export type CanDeleteBoardOrganizationQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'products'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id'>
    )>, prefs: (
      { __typename: 'Organization_Prefs' }
      & { boardDeleteRestrict?: Types.Maybe<(
        { __typename: 'Organization_Prefs_BoardDeleteRestrict' }
        & Pick<Types.Organization_Prefs_BoardDeleteRestrict, 'private' | 'org' | 'enterprise' | 'public'>
      )> }
    ) }
  )> }
);




/**
 * __useCanDeleteBoardOrganizationQuery__
 *
 * To run a query within a React component, call `useCanDeleteBoardOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDeleteBoardOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDeleteBoardOrganizationQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCanDeleteBoardOrganizationQuery(baseOptions: Apollo.QueryHookOptions<CanDeleteBoardOrganizationQuery, CanDeleteBoardOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDeleteBoardOrganizationQuery, CanDeleteBoardOrganizationQueryVariables>(CanDeleteBoardOrganizationDocument, options);
      }
export function useCanDeleteBoardOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDeleteBoardOrganizationQuery, CanDeleteBoardOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDeleteBoardOrganizationQuery, CanDeleteBoardOrganizationQueryVariables>(CanDeleteBoardOrganizationDocument, options);
        }
export type CanDeleteBoardOrganizationQueryHookResult = ReturnType<typeof useCanDeleteBoardOrganizationQuery>;
export type CanDeleteBoardOrganizationLazyQueryHookResult = ReturnType<typeof useCanDeleteBoardOrganizationLazyQuery>;
export type CanDeleteBoardOrganizationQueryResult = Apollo.QueryResult<CanDeleteBoardOrganizationQuery, CanDeleteBoardOrganizationQueryVariables>;